export const RO = 'Ростовская';
export const MO = 'Москва';
export const KK = 'Краснодарский';
export const SK = 'Ставропольский';
export const RA = 'Адыгея';
export const VO = 'Волгоградская';
export const NO = 'Нижегородская';

export const RO_NAME = 'Ростовская область';
export const MO_NAME = 'Москва';
export const KK_NAME = 'Краснодарский край';
export const SK_NAME = 'Ставропольский край';
export const RA_NAME = 'Республика Адыгея';
export const VO_NAME = 'Волгоградская область';
export const NO_NAME = 'Нижегородская область';

export const RO_ID = 'b0e6a3cc-7e9b-11e7-bffd-628caf01d019';
export const MO_ID = 'b0d0395e-7e9b-11e7-bffd-628caf01d019';
export const KK_ID = 'c473af93-7e9b-11e7-bffd-628caf01d019';
export const SK_ID = 'ca55fb99-7e9b-11e7-bffd-628caf01d019';
export const RA_ID = 'cb021919-7e9b-11e7-bffd-628caf01d019';
export const VO_ID = 'cb190e57-7e9b-11e7-bffd-628caf01d019';
export const NO_ID = 'cc660ea8-7e9b-11e7-bffd-628caf01d019';

export const REGIONS = [
    {
        shortName: RO,
        name: RO_NAME,
        id: RO_ID,
    },
    {
        shortName: MO,
        name: MO_NAME,
        id: MO_ID,
    },
    {
        shortName: KK,
        name: KK_NAME,
        id: KK_ID,
    },
    {
        shortName: SK,
        name: SK_NAME,
        id: SK_ID,
    },
    {
        shortName: RA,
        name: RA_NAME,
        id: RA_ID,
    },
    {
        shortName: VO,
        name: VO_NAME,
        id: VO_ID,
    },
    {
        shortName: NO,
        name: NO_NAME,
        id: NO_ID,
    },
];
